<form #businessInfoForm="ngForm">
    <p-fieldset styleClass="mt-2">
        <ng-template pTemplate="header">
            <div class="d-flex">
                <fa-icon [icon]='["far","info-circle"]'></fa-icon>
                <div class="mx-2">
                    Some Business Info
                </div>
                <fa-icon [icon]='["far","check-double"]' *ngIf="sectionComplete"></fa-icon>
                <div class="ms-auto">
                    <fa-icon [icon]='["far","question-circle"]' (click)="displayModal.emit('business')"></fa-icon>
                </div>
            </div>
        </ng-template>
        <div class="d-flex flex-wrap">
            <div class="mt-2 mx-2">
                <mat-form-field class="">
                    <mat-label>Business age (years)?</mat-label>
                    <mat-select #yearsInBusiness (valueChange)="inputAction($event);setBusinessAge()" name="yearsInBusiness"
                        [formControl]="yearsInBusinessControl" [(ngModel)]="application.yearsInBusiness">
                        <mat-option *ngFor="let value of businessAgeValues" [value]="value.value">
                            {{value.label}}
                        </mat-option>
                    </mat-select>
                    <mat-error *ngIf="yearsInBusinessControl.errors">
                        <span *ngIf="yearsInBusinessControl.hasError('required')">Required</span>
                    </mat-error>
                </mat-form-field>
            </div>
            <div class="mt-2 mx-2">
                <mat-form-field class="">
                    <mat-label>Years under current ownership?</mat-label>
                    <mat-select #yearsOfCurrentOwnership
                        (valueChange)="inputAction($event); "
                        name="yearsOfCurrentOwnership" [formControl]="yearsInBusinessControl"
                        [(ngModel)]="application.yearsOfCurrentOwnership">
                        <mat-option *ngFor="let value of businessAgeValues" [value]="value.value" [disabled]="value.disabled">
                            {{value.label}}
                        </mat-option>
                    </mat-select>
                    <mat-error *ngIf="yearsOfCurrentOwnershipControl.errors">
                        <span *ngIf="yearsOfCurrentOwnershipControl.hasError('notANumber')">Your length of ownership
                            needs to be a number.</span>
                        <span *ngIf="yearsOfCurrentOwnershipControl.hasError('min')">Your length of ownership cannot be
                            less than 0</span>
                        <span *ngIf="yearsOfCurrentOwnershipControl.hasError('max')">Your length of ownership can't be
                            longer than the business age.</span>
                    </mat-error>
                </mat-form-field>
            </div>
            <div class="mt-2 mx-2">
                <mat-form-field class="">
                    <mat-label>Estimated Average Check</mat-label>
                    <mat-icon matSuffix>
                        <fa-icon [icon]='["far","dollar-sign"]'></fa-icon>
                    </mat-icon>
                    <mat-select #estimatedAverageTicket (valueChange)="inputAction($event)"
                        name="estimatedAverageTicket" [formControl]="estimatedAverageTicketControl"
                        [(ngModel)]="application.estimatedAverageTicket">
                        <mat-option *ngFor="let value of estimatedTicketValues" [value]="value.value">
                            {{value.label}}
                        </mat-option>
                    </mat-select>
                    <mat-error *ngIf="estimatedAverageTicketControl.errors">
                        <span *ngIf="estimatedAverageTicketControl.hasError('required')">Required</span>
                    </mat-error>
                </mat-form-field>
            </div>
            <div class="mt-2 mx-2">
                <mat-form-field class="">
                    <mat-label>Estimated Monthly Volume</mat-label>
                    <mat-icon matSuffix>
                        <fa-icon [icon]='["far","dollar-sign"]'></fa-icon>
                    </mat-icon>
                    <mat-select #estimatedVolume (valueChange)="inputAction($event)" name="estimatedVolume"
                        [formControl]="estimatedVolumeControl" [(ngModel)]="application.estimatedVolume">
                        <mat-option *ngFor="let value of estimatedVolumeValues" [value]="value.value">
                            {{value.label}}
                        </mat-option>
                    </mat-select>
                    <mat-error *ngIf="estimatedAverageTicketControl.errors">
                        <span *ngIf="estimatedAverageTicketControl.hasError('required')">Required</span>
                    </mat-error>
                </mat-form-field>
            </div>
        </div>
    </p-fieldset>
</form>